import { StateKey } from 'common/utils/flipState'
import { isErrorRejected } from 'common/utils/ajax/apiErrorHandler'
import HttpStatus from 'common/utils/httpStatus'
import logger from 'common/logger'
import { MY_PAY_DEFAULT_VALUE } from '../../constants/naverPay'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

const initialState: string = MY_PAY_DEFAULT_VALUE

const FETCH_MY_COUPON_COUNTS = 'my/FETCH_MY_COUPON_COUNTS'

export const fetchMyCouponCounts = (curState: StateKey, headers?: any) => async dispatch => {
  try {
    const response = await axios.get(`/v1/pay/coupon-counts`, {
      ...getHeaders(headers),
      data: {
        [isErrorRejected]: true,
      },
    })

    dispatch({
      curState,
      type: FETCH_MY_COUPON_COUNTS,
      couponCounts: response && response.data,
    })
  } catch (err) {
    err.response.status !== HttpStatus.UNAUTHORIZED && logger.error(err)
    dispatch({
      curState,
      type: FETCH_MY_COUPON_COUNTS,
      couponCounts: initialState,
    })
  }
}

const myCouponCountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MY_COUPON_COUNTS:
      return action.couponCounts
    default:
      return state
  }
}

export default myCouponCountsReducer
